module.exports = __webpack_public_path__ + "static/media/bg3.1e0b91ff.png";